import { render } from "./SetupSidebar.vue?vue&type=template&id=67837016&scoped=true"
import script from "./SetupSidebar.vue?vue&type=script&lang=js"
export * from "./SetupSidebar.vue?vue&type=script&lang=js"

import "./SetupSidebar.vue?vue&type=style&index=0&id=67837016&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67837016"]])

export default __exports__